import React, {Component} from 'react';
import {withRouter, Switch, Route, Redirect} from 'react-router-dom';
import ChooseTariffModel from './containers/ChooseTariffModel';
import TvChannels from './containers/TvChannels';
import axios from "./custom-axios/tvchannels";
import {CitiesContext} from "./context/CitiesContext";
import MunicipalityRepository from "./repository/MunicipalityRepository";

const queryString = require('query-string');

class App extends Component {
    constructor(props) {
        super(props);
        this.municipalityInputRef = React.createRef();
        this.state = {
            tariffTypes: [],
            tariffModelShortNames: null,
            cities: [],
            municipalities: [],
            selectedCity: undefined,
            selectedMunicipality: undefined,
            technologyType: undefined,
            selectedCityName: undefined,
            selectedMunicipalityName: undefined,
            autocompleteCities: [],
            autocompleteMunicipalities: [],
            showChangeCityBtn: false,
            firstLoadApp: true
        }
    }

    render() {
        return (
            <div className="App">
                <CitiesContext.Provider value={{
                    cities: this.state.cities,
                    municipalities: this.state.municipalities,
                    selectedCity: this.state.selectedCity,
                    selectedMunicipality: this.state.selectedMunicipality,
                    technologyType: undefined,
                    selectedCityName: undefined,
                    selectedMunicipalityName: undefined,
                    autocompleteCities: [],
                    autocompleteMunicipalities: []
                }}>
                    <Switch>
                        <Route path={"/choose-tariff-model"}
                               render={(props) => <ChooseTariffModel {...props} tariffTypes={this.state.tariffTypes}
                                                                     tariffModelShortNames={this.state.tariffModelShortNames}
                                                                     cities={this.state.cities}
                                                                     municipalities={this.state.municipalities}
                                                                     selectedCity={this.state.selectedCity}
                                                                     selectedMunicipality={this.state.selectedMunicipality}
                                                                     selectCity={(cityId) => this.selectCity(cityId)}
                                                                     selectMunicipality={(municipalityId) => this.selectMunicipality(municipalityId)}
                                                                     selectedCityName={this.state.selectedCityName}
                                                                     selectedMunicipalityName={this.state.selectedMunicipalityName}
                                                                     autocompleteCities={this.state.autocompleteCities}
                                                                     autocompleteMunicipalities={this.state.autocompleteMunicipalities}
                                                                     setSelectedCityName={(name) => this.setSelectedCityName(name)}
                                                                     setSelectedMunicipalityName={(name) => this.setSelectedMunicipalityName(name)}
                                                                     lang={this.props.lang}/>}/>
                        <Route path={"/tv-channels"}
                               render={(props) => <TvChannels {...props} tariffTypes={this.state.tariffTypes}
                                                              technologyType={this.state.technologyType}
                                                              tariffModelShortNames={this.state.tariffModelShortNames}
                                                              cities={this.state.cities}
                                                              municipalities={this.state.municipalities}
                                                              selectedCity={this.state.selectedCity}
                                                              selectedMunicipality={this.state.selectedMunicipality}
                                                              selectCity={(cityId) => this.selectCity(cityId)}
                                                              selectMunicipality={(municipalityId) => this.selectMunicipality(municipalityId)}
                                                              technologyType={this.state.technologyType}
                                                              selectedCityName={this.state.selectedCityName}
                                                              selectedMunicipalityName={this.state.selectedMunicipalityName}
                                                              autocompleteCities={this.state.autocompleteCities}
                                                              autocompleteMunicipalities={this.state.autocompleteMunicipalities}
                                                              setSelectedCityName={(name) => this.setSelectedCityName(name)}
                                                              setSelectedMunicipalityName={(name) => this.setSelectedMunicipalityName(name)}
                                                              lang={this.props.lang}
                                                              municipalityInputRef={this.municipalityInputRef}
                                                              showChangeCityBtn={this.state.showChangeCityBtn}/>}/>
                        <Redirect to={"/choose-tariff-model"}/>
                    </Switch>
                </CitiesContext.Provider>
            </div>
        );
    }

    componentDidMount() {
        const params = queryString.parse(this.props.location.search);
        if (!params.city) {
            params.city = 25643
        }
        this.setState({
            selectedCity: parseInt(params.city)
        }, () => {
            this.fetchMunicipalities()
        })

        if (params.municipality) {
            this.setState({
                selectedMunicipality: parseInt(params.municipality)
            })
        }

        if (!params.city || !params.municipality) {
            const search = 'city=25643&tariffModel=1439&tariffType=1414';
            this.props.history.push({
                pathname: "/tv-channels",
                search: search
            })
        }

        this.fetchCities();
        this.fetchTariffTypes();
        this.fetchTariffModelShortNames();
    }

    fetchCities() {
        axios.get('/city/all')
            .then(response => this.setState(
                {
                    cities: response.data,
                    autocompleteCities: response.data
                }, () => {
                    if (this.state.selectedCity) {
                        const selectedCity = this.state.cities.find(c => c.id == this.state.selectedCity)
                        this.setState({
                            selectedCityName: this.translateName(selectedCity)
                        })
                    }
                })
            ).catch(error => console.log(error))
    }

    fetchMunicipalities() {
        MunicipalityRepository.fetchMunicipalities(this.state.selectedCity, this.props.lang)
            .then(response => {
                this.setState(
                    {
                        municipalities: response.data,
                        autocompleteMunicipalities: response.data,
                        showChangeCityBtn: response.data.length<=1
                    }, () => {
                        const selectedMunicipality = this.state.municipalities.find(m => m.id == this.state.selectedMunicipality)
                        if (!selectedMunicipality) {
                            this.setState({
                                selectedMunicipality: this.state.municipalities[0],
                                technologyType: this.state.municipalities.find(m => m.id == this.state.municipalities[0].id).technologyType
                            })
                            if(response.data.length<=1){
                                this.setSelectedMunicipalityName(this.translateName(this.state.municipalities[0]))
                            }

                        } else {
                            this.setState({
                                technologyType: this.state.municipalities.find(m => m.id == this.state.selectedMunicipality).technologyType
                            })
                            this.setSelectedMunicipalityName(this.translateName(selectedMunicipality))
                        }

                        if(((response.data.length)>=1) && !this.state.firstLoadApp){
                            this.municipalityInputRef.current.focus()
                        }else{
                            this.setState({
                                firstLoadApp: false
                            })
                        }
                    })
            })
            .catch(error => console.log(error))

    }

    fetchTariffTypes() {
        axios.get('/tariff-type')
            .then(response => {
                this.setState({
                    tariffTypes: response.data
                })
            }).catch(error => console.log(error));
    }

    fetchTariffModelShortNames() {
        axios.get('/tariff-model/short-name')
            .then(response => {
                this.setState({
                    tariffModelShortNames: response.data
                })
            }).catch(error => {
            console.log(error);
        });
    }

    selectCity(cityId) {
        const city = this.state.cities.find(c => c.id == cityId)

        this.setState({
            selectedCity: cityId,
            selectedCityName: this.translateName(city),
            autocompleteCities: this.state.cities,
            selectedMunicipality: undefined,
            technologyType: undefined
        }, () => {
            this.setSelectedMunicipalityName(undefined)
            this.fetchMunicipalities()
            this.updateQueryParams("city", cityId)

        })
    }

    selectMunicipality(municipalityId) {
        const municipality = this.state.municipalities.find(m => m.id == municipalityId)
        this.setState({
            selectedMunicipality: municipalityId,
            selectedMunicipalityName: this.translateName(municipality),
            autocompleteMunicipalities: this.state.municipalities,
            technologyType: this.state.municipalities.find(mun => mun.id == municipalityId)?.technologyType,
            showChangeCityBtn: true
        }, () => {
            this.updateQueryParams("municipality", municipalityId)
        })
    }

    updateQueryParams(key, value, remove) {
        const params = queryString.parse(this.props.location.search);
        if (remove) {
            if (Array.isArray(params[key])) {
                params[key] = params[key].filter(p => p != value);
                if (params[key].length === 0) {
                    delete params[key];
                }
            } else {
                delete params[key];
            }
        } else {
            if (Array.isArray(params[key]))
                params[key].push(value);
            else if (key === 'freePackage' || key === 'additionalPackage') {
                if (params[key]) {
                    let values = [params[key], value];
                    params[key] = values;
                } else params[key] = value;
            } else
                params[key] = value;
        }

        let qs = "?";
        Object.keys(params)
            .filter(k => ['city', 'municipality', 'tariffType', 'tariffModel'].includes(k))
            .forEach(key => {
                if (Array.isArray(params[key])) {
                    params[key].forEach(p => {
                        qs += `${key}=${p}&`
                    })
                } else {
                    qs += `${key}=${params[key]}&`
                }
            });
        this.props.history.push(`${this.props.location.pathname}${qs.substring(0, qs.length - 1)}`);
    }

    removeQueryParams = (keys) => {
        const params = queryString.parse(this.props.location.search)
        keys.forEach(k => delete params[k])
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: queryString.stringify(params)
        })
    }

    setAutocompleteCities() {
        const cities = this.state.selectedCityName && this.state.selectedCityName.length > 0 ?
            this.state.cities
                .filter(c =>
                    this.translateName(c)
                        .toLowerCase()
                        .startsWith(this.state.selectedCityName.toLowerCase().transcript(this.props.lang)))
            :
            this.state.cities

        this.setState({
            autocompleteCities: cities
        })
    }

    setSelectedCityName(selectedCityName) {
        this.setState({
            selectedCityName: selectedCityName,
            selectedMunicipalityName: undefined,
            selectedCity: undefined,
            selectedMunicipality: undefined,
            autocompleteMunicipalities: []
        }, () => {
            this.setAutocompleteCities()
            this.removeQueryParams(["city", "municipality"])
        })

    }

    setAutocompleteMunicipalities() {
        const municipalities = this.state.selectedMunicipalityName && this.state.selectedMunicipalityName.length > 0 ?
            this.state.municipalities.filter(m =>
                this.translateName(m)
                    .toLowerCase()
                    .startsWith(this.state.selectedMunicipalityName.transcript(this.props.lang).toLowerCase()))
            :
            this.state.municipalities

        this.setState({
            autocompleteMunicipalities: municipalities
        })
    }

    setSelectedMunicipalityName(selectedMunicipalityName) {
        const municipality = this.state.municipalities.find(m => m.id == this.state.selectedMunicipality)
        this.setState({
            selectedMunicipalityName: selectedMunicipalityName
        }, () => {
            this.setAutocompleteMunicipalities()
            if (municipality) {
                if (selectedMunicipalityName !== this.translateName(municipality)) {
                    this.setState({
                        selectedMunicipality: undefined
                    }, () => {
                        this.removeQueryParams(["municipality"])
                    })
                }
            }
        })
    }

    translateName(obj) {
        if (this.props.lang === 'en_US') {
            return obj.nameEN
        } else if (this.props.lang === 'sq_AL') {
            return obj.nameAL
        } else return obj.nameMK
    }
}

export default withRouter(App);
